var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('edit-form',{attrs:{"model":_vm.model,"typeName":_vm.typeName},on:{"saveitem":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }